// @flow
'use strict';

import * as React from 'react';

import type { IRps } from '../types';

import RowDetalhes from '../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../common/detalhes_documento/column_detalhes';

export default function Rps({ item } : { item : IRps }) {
  return (
      <div className="tab-pane active">
        <h3>RPS</h3>
        <RowDetalhes data={ item }>
          <ColumnDetalhes field="inscricaoPrestador" width="20%">IM Prestador</ColumnDetalhes>
          <ColumnDetalhes field="serie" width="20%">Série</ColumnDetalhes>
          <ColumnDetalhes field="numero" width="20%">Número</ColumnDetalhes>
          <ColumnDetalhes field="tipo" width="40%">Tipo</ColumnDetalhes>
        </RowDetalhes>

        <RowDetalhes data={ item }>
          <ColumnDetalhes field="dataEmissao" type="data" width="20%">Data Emissão</ColumnDetalhes>
          <ColumnDetalhes field="status" width="20%">Status RPS</ColumnDetalhes>
          <ColumnDetalhes field="tributacao" type="tributacao" width="60%">Tributação</ColumnDetalhes>
        </RowDetalhes>
      </div>
  );
}